import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { ApiService } from 'src/app/providers/api.service';
import { SM_CONSTANTS } from '../../constants/sm-constants';
import { LoaderServiceService } from 'src/app/providers/loader-service.service';
import { AlertService } from 'src/app/providers/alert.service';

@Component({
  selector: 'sm-follower-report-abuse',
  templateUrl: './follower-report-abuse.component.html',
  styleUrls: ['./follower-report-abuse.component.scss']
})
export class FollowerReportAbuseComponent implements OnInit {
  message:any
  allReportTypeStatus: any = [
    {
    name: "Spam",
    status: false
  },
    {
    name: "Violence",
    status: false
  },
    {
    name: "Offence",
    status: false
  },
    {
    name: "False News",
    status: false
  },
    {
    name: "Political Issue",
    status: false
  },
    {
    name: "Something Else",
    status: false
  },
]
private _apisub: Subscription
  constructor(    @Inject(MAT_DIALOG_DATA) public parentData: any, private apiservice: ApiService, private loader: LoaderServiceService, private _alertService: AlertService) { 
    this._apisub = this.apiservice.apiResult.subscribe(resdata =>{
      if(resdata.responseType === SM_CONSTANTS.RESULT_API_SET_REQUEST){
        if(resdata.result){
          this.loader.showLoader = false
          this._alertService.onOpenSnackbar("Abuse report sent successfully.");
          this.parentData.ref.closeAll()
        }
      }
    })
  } 

  ngOnInit(): void {
  }

  changeReportStatus(value:any){
    this.allReportTypeStatus[value].status = !this.allReportTypeStatus[value].status
  }

  submit(){
    this.loader.showLoader = true
    let bodyData = {
      "requestInfo": {
          "requestType": 1,
          "message": this.message,
          "note": null,
          "requestToName": this.parentData.name,
          "requestPhone": null,
          "requestStatus": 5,
          "categoryType": this.concatenateNames(this.allReportTypeStatus)
      }
  }

  console.log(bodyData);
  
  this.apiservice.setRequestReport(bodyData,this.parentData.followerHash)
    
  }
  
  concatenateNames(reportTypes:any) {
    // Filter out items with status true
    const filteredItems = reportTypes.filter((item:any) => item.status === true);
    
    // Map the filtered items to their names
    const names = filteredItems.map((item:any) => item.name);
    
    // Join the names with a comma separator
    return names.join(',');
  }
}
